const initialState = {
  location: null,
  zone: [],
  area: '',
  locationItem: null,
  liveLocation: {},
  zoneAdditionalData: [],
};

const actions = {
  SET_LOCATION: 'location/SET_LOCATION',
  SET_SELECTED_LOCATION: 'location/SET_SELECTED_LOCATION',
  SET_ZONE: 'location/SET_ZONE',
  SET_AREA: 'location/SET_AREA',
  SET_LOCATION_ITEM: 'location/SET_LOCATION_ITEM',
  SET_LIVE_LOCATION: 'location/SET_LIVE_LOCATION',
  SET_ADDITIONAL_ZONE_DATA: 'location/SET_ADDITIONAL_ZONE_DATA',
};

export const UserLocationReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
  if (action.type === actions.SET_LOCATION) {
    return {
      ...state,
      location: action.payload,
    };
  } else if (action.type === actions.SET_SELECTED_LOCATION) {
    return {
      ...state,
      selectedLocation: action.payload.selectedLocation,
    };
  } else if (action.type === actions.SET_LIVE_LOCATION) {
    return {
      ...state,
      liveLocation: action.payload,
    };
  } else if (action.type === actions.SET_ZONE) {
    return {
      ...state,
      zone: action.payload,
    };
  } else if (action.type === actions.SET_AREA) {
    return {
      ...state,
      area: action.payload,
    };
  } else if (action.type === actions.SET_LOCATION_ITEM) {
    return {
      ...state,
      locationItem: action.payload,
    };
  } else if (action.type === actions.SET_ADDITIONAL_ZONE_DATA) {
    return {
      ...state,
      zoneAdditionalData: action.payload,
    };
  } else {
    return state;
  }
};

export const setUserLocationData = (latlng) => ({
  type: actions.SET_LOCATION,
  payload: latlng,
});

export const setSelectedLocationData = (selectedLocation) => ({
  type: actions.SET_SELECTED_LOCATION,
  payload: selectedLocation,
});

export const setUserZoneData = (zone) => ({
  type: actions.SET_ZONE,
  payload: zone,
});

export const setUserArea = (area) => ({
  type: actions.SET_AREA,
  payload: area,
});

export const setLocationItemReducer = (item) => ({
  type: actions.SET_LOCATION_ITEM,
  payload: item,
});

export const setLiveLocationReducer = (location) => ({
  type: actions.SET_LIVE_LOCATION,
  payload: location,
});

export const setAdditionalZoneData = (zone) => ({
  type: actions.SET_ADDITIONAL_ZONE_DATA,
  payload: zone,
});

export default UserLocationReducer;
